import { useCallback } from "react";
import { listStartRouteOptions } from "../../../api/threads/routeOptions";
import { useLoad, type LoadState } from "../../../shared/loading/useLoad";

/**
 * Whether a start of `workflow` at `contentVersion` needs an LLM: the server's answer (route
 * options' `needsRoute`, Sol R3 S9), asked before any PC is chosen; `false` with no Workflow.
 */
export function useStartRouteNeed(projectId: string, workflow: string | null, contentVersion: string | null): LoadState<boolean> {
  const load = useCallback(
    async (signal: AbortSignal) => (workflow === null || contentVersion === null ? false : (await listStartRouteOptions({ projectId, workflow, contentVersion, routes: null }, null, signal)).needsRoute),
    [projectId, workflow, contentVersion],
  );
  return useLoad(load).state;
}
